import { Typography } from '@mui/material'

interface Props {
  data: uui.domain.client.rm.OrderStepEmailNotification
}

export function NotificationSubject(props: Props) {
  const { data } = props

  return <Typography variant="body1">{data.subject}</Typography>
}
